"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
var _remeda = require("remeda");
const debounceFrameDelay = 32;
let index = 1;
let debounceCount = 0;
let debounces = {};
let intervalId;
let running = false;
function run() {
  if (running) {
    console.warn("Skipping debounce frame, as previous frame is still running.");
    // Skip run if the last one is still running
    return;
  }
  running = true;
  try {
    let now = Date.now();
    for (let it of Object.values(debounces)) {
      let invoke = false;
      let diff = now - it.lastInvoke;
      if (diff >= it.timeout) {
        invoke = true;
      } else if (it.maxWait) {
        let max = now - it.firstInvoke;
        if (max >= it.maxWait) {
          invoke = true;
        }
      }
      if (invoke) {
        let resolve = it.resolve;
        let reject = it.reject;
        it.promise = null;
        removeInstance(it);
        try {
          let result = it.func.apply(it.context, it.args);
          if ((0, _remeda.isPromise)(result)) {
            result.then(resolve).catch(reject);
          } else {
            resolve(result);
          }
        } catch (err) {
          reject(err);
        }
      }
    }
  } finally {
    running = false;
  }
  checkInterval();
}
function checkInterval() {
  if (debounceCount > 0) {
    if (!intervalId) {
      intervalId = setInterval(run, debounceFrameDelay);
    }
  } else {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = undefined;
    }
  }
}
function addInstance(instance) {
  if (debounces[instance.index]) {
    console.error("Debounce instance already in record, this shouldn't happen!");
  } else {
    debounceCount += 1;
  }
  debounces[instance.index] = instance;
  checkInterval();
}
function removeInstance(instance) {
  if (!debounces[instance.index]) {
    console.error("Removing debounce failed, instance doesn't exist!");
    return;
  }
  delete debounces[instance.index];
  debounceCount -= 1;
}
function createDebounce(instance) {
  const debouncedFunction = function (...args) {
    instance.context = this;
    instance.args = args;
    instance.lastInvoke = Date.now();
    if (!instance.promise) {
      instance.firstInvoke = instance.lastInvoke;
      instance.promise = new Promise((resolve, reject) => {
        instance.resolve = resolve;
        instance.reject = reject;
      });
      addInstance(instance);
    }
    return instance.promise;
  };
  debouncedFunction.cancel = function (reason) {
    if (instance.promise) {
      instance.promise = null;
      removeInstance(instance);
      instance.reject(reason);
    }
  };
  return debouncedFunction;
}
function debounce(func, waitMilliseconds = 500, options = {}) {
  let instance = {
    ...options,
    index: index++,
    func,
    timeout: waitMilliseconds
  };
  return createDebounce(instance);
}
//# sourceMappingURL=framed-debounce.js.map